import React from 'react';

import { Button, Input, Modal, message } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { ErrorMessage, Formik } from 'formik';
import { T } from 'react-translator-component';

import { updatePushSchedule } from '../../../hooks/schedules';
import PushScheduleFields from '../PushScheduleFields';
import { describeSaveError } from '../PushScheduleFields/scheduleErrors';
import { validateScheduleFields } from '../PushScheduleFields/scheduleValues';
import { fromEditFormValues, toEditFormValues } from './scheduleEdit';

const PushScheduleEditModal = ({ schedule, onClose, onSaved }) => {
  if (!schedule) {
    return null;
  }

  return (
    <Formik
      initialValues={toEditFormValues(schedule)}
      validate={(values) => {
        const errors = {};
        if (!values.subject) {
          errors.subject = T('O campo título é obrigatório.');
        }
        if (!values.message) {
          errors.message = T('O campo mensagem é obrigatório.');
        }
        Object.assign(errors, validateScheduleFields(values));
        return errors;
      }}
      onSubmit={async (values, { setSubmitting }) => {
        try {
          await updatePushSchedule(schedule.uuid, fromEditFormValues(values, schedule));
          message.success(T('Agendamento atualizado com sucesso'));
          setSubmitting(false);
          if (typeof onSaved === 'function') {
            onSaved();
          }
        } catch (error) {
          setSubmitting(false);
          message.error(describeSaveError(error));
        }
      }}
    >
      {({
        values,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
      }) => (
        <Modal
          visible
          title={T('Editar agendamento')}
          onCancel={onClose}
          maskClosable={false}
          footer={[
            <Button key='cancel' onClick={onClose}>
              {T('Cancelar')}
            </Button>,
            <Button key='save' type='primary' loading={isSubmitting} onClick={handleSubmit}>
              {T('Salvar')}
            </Button>,
          ]}
        >
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontWeight: 600, display: 'block', marginBottom: 4 }}>
              {T('Título')}*:
            </label>
            <Input
              name='subject'
              value={values.subject}
              onChange={handleChange}
              onBlur={handleBlur}
              maxLength={255}
            />
            <ErrorMessage name='subject' component='div' className='error' />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ fontWeight: 600, display: 'block', marginBottom: 4 }}>
              {T('Mensagem')}*:
            </label>
            <TextArea
              name='message'
              value={values.message}
              onChange={handleChange}
              onBlur={handleBlur}
              maxLength={255}
              rows={4}
            />
            <ErrorMessage name='message' component='div' className='error' />
          </div>

          {/*
            A audiência (targetType/userPks/regionFilter) NÃO aparece aqui de propósito:
            fromEditFormValues sempre usa o alvo do registro original — ver scheduleEdit.ts.
          */}
          <PushScheduleFields
            values={values}
            setFieldValue={setFieldValue}
            showModeCards={false}
            timezoneLabel={schedule.timezone}
          />
        </Modal>
      )}
    </Formik>
  );
};

export default PushScheduleEditModal;
